<template>
  <router-view />
</template>

<script>
export default {
  name: "ProfileLayout"
};
</script>

